<template>
  <v-row>
    <v-col xl="auto" lg="auto" md="auto" cols="12" class="pt-0 pb-0 pr-0">
      {{ label }}
    </v-col>
    <v-col
      xl="auto"
      lg="auto"
      md="auto"
      cols="12"
      class="font-weight-bold pt-0 pb-0"
    >
      {{ value }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    label: String,
    value: null,
  },
};
</script>

<style>
</style>